"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createOptions_1 = require("./createOptions");
const createLogger_1 = require("./createLogger");
const detectFallback_1 = require("./detectFallback");
const detectServer_1 = require("./detectServer");
exports.createContext = (config) => {
    const options = createOptions_1.createOptions(config);
    const logger = createLogger_1.createLogger(options);
    const isServer = detectServer_1.detectServer();
    const isFallback = detectFallback_1.detectFallback();
    const mechanism = isServer
        ? "serversync"
        : isFallback
            ? "cookiesync"
            : "storagesync";
    return { options, logger, mechanism, isServer, isFallback };
};
//# sourceMappingURL=createContext.js.map